import { render, staticRenderFns } from "./ProgramEditor.vue?vue&type=template&id=bf30e0de&scoped=true"
import script from "./ProgramEditor.vue?vue&type=script&lang=js"
export * from "./ProgramEditor.vue?vue&type=script&lang=js"
import style0 from "./ProgramEditor.vue?vue&type=style&index=0&id=bf30e0de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf30e0de",
  null
  
)

export default component.exports